export default ["blue", "lightblue", "black"];
